import { createFileRoute, Navigate } from '@tanstack/react-router';
import { DASHBOARDS } from '~/lib/dashboards';

/** /dashboards/<key> with no tab specified → redirect to the first tab. */
export const Route = createFileRoute('/_app/dashboards/$dashboard/')({
  component: DashboardIndex,
});

function DashboardIndex() {
  const { dashboard: key } = Route.useParams();
  const dashboard = DASHBOARDS[key];
  if (!dashboard || dashboard.tabs.length === 0) {
    return <div className="text-sm text-[var(--color-ink-muted)]">Unknown section.</div>;
  }

  const tab = dashboard.tabs[0].key;
  return <Navigate to="/dashboards/$dashboard/$tab" params={{ dashboard: key, tab }} replace />;
}
